import { Component, OnInit } from '@angular/core';
import { UserSessionService } from "../shared/service/user-session.service";
import { ManagedContentService } from "../shared/service/managed-content.service";
import { HEADER_MESSAGE_COLOR } from '../shared/model/header-message-color';
import { CmHeaderMessage } from '../shared/model/cm-header-message';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-maintenance-notification',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './maintenance-notification.component.html',
  styleUrls: ['./maintenance-notification.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaintenanceNotificationComponent implements OnInit {
  constructor(private cmService: ManagedContentService,
              private userSessionService: UserSessionService){
  }
  public displayMessage: CmHeaderMessage = {
    id: 'header-message',
    message: '',
    color: HEADER_MESSAGE_COLOR.DEFAULT,
    closable: 'true'
  };
 public visible = false;
 ngOnInit(){
   this.setVisibility();
 }

 async setVisibility() {
   
   if (this.userSessionService.data.maintenance_time.trim()!='') {
       this.displayMessage.message = this.userSessionService.data.maintenance_time.trim();
       this.visible = true;
   } else {
       this.visible = false;
   }
 }
}
